// import enum
import {StatusEnum} from "@/enum/status.enum.js";

export const state = {
  filterApplication: {
    code: "",
    name: "",
    status: [],
    isFilter: false,
  },
  applicationSelected: {
    id: "",
    name: "",
    code: "",
    isFilter: false,
  },
};
export const mutations = {
  ADD_FILTER_APPLICATION: (state, data) => {
    state.filterApplication = data;
    state.filterApplication.isFilter = true;
  },
  CLEAR_FILTER_APPLICATION: state => {
    state.filterApplication = {
      code: "",
      name: "",
      status: [],
    };
  },
  ADD_APPLICATION_SELECTED: (state, data) => {
    state.applicationSelected = data;
    state.applicationSelected.isFilter = true;
  },
};
export const getters = {
  GET_FILTER_APPLICATION: state => {
    return state.filterApplication;
  },
  GET_APPLICATION_SELECTED: state => {
    return state.applicationSelected;
  },
};
export const actions = {
  ADD_FILTER_APPLICATION: ({commit}, data) => {
    commit("ADD_FILTER_APPLICATION", data);
  },
  CLEAR_FILTER_APPLICATION: ({commit}) => {
    commit("CLEAR_FILTER_APPLICATION");
  },
  ADD_APPLICATION_SELECTED: ({commit}, data) => {
    commit("ADD_APPLICATION_SELECTED", data);
  },
};
